import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PushNotificationsService } from "@app/main/content/push-notifications/push-notifications.service";

@Component({
  selector: "dropdown-menu",
  templateUrl: "./dropdown-menu.component.html",
  styleUrls: ["./dropdown-menu.component.scss"],
})
export class DropdownMenuComponent implements OnInit {
  navItems: any[] = [
    {
      label: "Select recipients",
      children: [
        { label: "Send to all", value: "all" },
        {
          label: "Categories",
          value: "categories",
          children: [],
        },
        {
          label: "Group",
          value: "group",
          children: [],
        },
      ],
    },
  ];

  constructor(private _pushNotificationsService: PushNotificationsService) {
    this.initializeNavItems();
  }

  ngOnInit() {}

  initializeNavItems() {
    this._pushNotificationsService.categories.forEach((category) => {
      this.navItems[0].children[1].children.push({
        label: category.name,
        value: category.name,
        type: "category",
        id: category.id,
        children: category.games,
      });
    });
    this._pushNotificationsService.privateGames.forEach((item) => {
      this.navItems[0].children[2].children.push({
        label: item.game.title,
        value: item.game.title,
        type: "private game",
        id: item.game.id,
        players: item.players.length !== 0 ? item.players : [],
      });
    });
    console.log("navItems.....", this.navItems);
  }

  selectedMenuItems(value) {
    this._pushNotificationsService.selectedMenuItem = value;
  }
}
